import { render, staticRenderFns } from "./DiagnosticPicker.vue?vue&type=template&id=da36039a"
import script from "./DiagnosticPicker.vue?vue&type=script&lang=ts"
export * from "./DiagnosticPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports